export const studyPackAccessNote =
	"Note: Study-Packs can only be accessed via our mobile apps. Please download the appropriate app for your device.";
